import {getElementChildren, getElements} from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class NavAnchor {
  private readonly item: HTMLElement | null
  private links: [] | NodeListOf<HTMLElement>
  private markers: HTMLElement[]
  private offset: number = 180

  constructor(item: HTMLElement) {
    this.item = item
    this.markers = []
    this.links = getElementChildren(this.item, 'nav-anchor-link')
  }

  public init(): void {
    this.addMarkers()
    this.addEvents()
  }

  private addEvents(): void {
    window.addEventListener('scroll', () => this.onScroll(), { passive: true })
  }

  private addMarkers(): void {
    this.links.forEach((link: HTMLElement): void => {
      const url = new URL((link as HTMLAnchorElement).href)
      const target: HTMLElement = document.querySelector(url.hash)

      if (!url.hash) {
        return
      }

      if (target === null) {
        return
      }

      this.markers.push(target)
    })
  }

  private onScroll(): void {
    let activeIndex: number = -1

    this.markers.forEach((marker: HTMLElement, index: number): void => {
      const markerTop: number = marker.getBoundingClientRect().top
      if (markerTop <= this.offset) {
        activeIndex = index
      }
    })

    this.links.forEach((link: HTMLElement, index: number): void => {
      if (index === activeIndex) {
        link.classList.add(IS_ACTIVE)

        const parent: HTMLElement = link.parentElement.parentElement
        if (parent) {
          const linkCenter: number = link.offsetLeft + link.offsetWidth / 2
          const parentCenter: number = parent.clientWidth / 2
          const targetScroll: number = linkCenter - parentCenter

          parent.scrollTo({
            behavior: 'smooth',
            left: targetScroll
          })
        }
      } else {
        link.classList.remove(IS_ACTIVE)
      }
    })
  }
}

const items: [] | NodeListOf<HTMLElement> = getElements('nav-anchor')
items.forEach((item: HTMLElement): void => {
  const navAnchor = new NavAnchor(item)
  navAnchor.init()
})
